import { z } from 'zod';

export const TeamRenameFormData = z.object({
  oldValue: z.string(),
  newValue: z.string().min(1, 'New value is required'),
  includeHistorical: z.boolean().default(true),
});
export type TeamRenameFormDataType = z.infer<typeof TeamRenameFormData>;
